import axios from 'axios';
import Swal from 'sweetalert2';
import { loadUser } from "./authActions";

export const creatItemBuffSub = (data) => (dispatch, getState) => {
	let bodysend = {
		dataform: data,
		type_api: 'buff_sub'
	};

	Swal.fire({
	  	title: 'Bạn có chắc?',
	  	text: "Bạn có chắc chắn muốn Order "+data.sltang+" FOLLOW với giá: "+data.giatien+" Coin/1 FOLLOW ? Khi đã bấm đồng ý đồng nghĩa với việc bạn đã đọc hết mục thông tin dịch vụ!",
	  	icon: 'warning',
	  	showCancelButton: true,
	  	confirmButtonColor: '#3085d6',
	  	cancelButtonColor: '#d33',
	  	confirmButtonText: 'Đồng ý',
	  	cancelButtonText: 'Không'
	}).then((result) => {
	  	if (result.value) {
			dispatch({
				type: 'LOADING_BLOCK_BUFF_SUB_IST',
				payload: true
			});

			axios.post('/api/instagram/create/', bodysend, tokenConfig(getState))
			.then(res => {
				dispatch(loadUser());
				dispatch({
					type: 'LOADING_BLOCK_BUFF_SUB_IST',
					payload: false
				});
				if (res.data.status === 400) {
					if (Array.isArray(res.data.error)) {
						if (res.data.error.length > 0) {
							openBtComfirmAlert(res.data.error[0], 'error', 'Lỗi');
						} else {
							openBtComfirmAlert(res.data.message, 'error', 'Lỗi');
						}
					} else if (typeof res.data.error === "object") {
						openBtComfirmAlert(res.data.error[Object.keys(res.data.error)[0]], 'error', 'Lỗi');
					} else {
						openBtComfirmAlert(res.data.message, 'error', 'Lỗi');
					}
				} else {
					openBtComfirmAlert('Thêm thành công', 'success', '');
				}
			});
	  	}
  	})
};

export const getListItemBuffSub = (viewadmin = 0, page = "", obj_search = '') => (dispatch, getState) => {
	const token = getState().auth.token;
	const dataPass = {
	    headers: {
	    	"Content-type": "application/json",
	    }
  	}

	if (token) {
		dataPass.headers['ht-token'] = token;
	}

	dispatch({
		type: 'LOADING_BLOCK_BUFF_SUB_IST',
		payload: true
	});

	let param_url = '';
	if (viewadmin === 1) {
		param_url = '&viewall=1';
	}
	if (page !== "") {
		param_url += '&page='+page;
	}
	param_url += '&obj_search='+obj_search;
	axios.get('/api/instagram/list/?type_api=buff_sub'+param_url, dataPass)
	.then(res => {
		dispatch({
			type: 'LOADING_BLOCK_BUFF_SUB_IST',
			payload: false
		});
		if (res.data.status === 200) {
			dispatch({
				type: 'LIST_BUFF_SUB_USER_IST',
				payload: res.data.data
			});
		}
	});
}

export const cancelOrderBuffSub = (id_order) => (dispatch, getState) => {
	if (id_order === null) {
		openBtComfirmAlert('Không có order được chọn!', 'error', 'Lỗi');
		return false;
	}

	Swal.fire({
	  	title: 'Bạn có chắc?',
	  	text: "Sau khi hủy bạn sẽ được hoàn lại số lượng chưa tăng sau 1 đến 3 ngày và trừ thêm 5.000 Coin phí để tránh Spam!",
	  	icon: 'warning',
	  	showCancelButton: true,
	  	confirmButtonColor: '#3085d6',
	  	cancelButtonColor: '#d33',
	  	confirmButtonText: 'Đồng ý',
	  	cancelButtonText: 'Không'
	}).then((result) => {
	  	if (result.value) {
	  		let bodysend = {
	  			id_remove: id_order,
	  			type_api: 'buff_sub',
	  		};
	  		dispatch({
				type: 'LOADING_BLOCK_BUFF_SUB_IST',
				payload: true
			});
	  		axios.post('/api/instagram/remove/', bodysend, tokenConfig(getState))
			.then(res => {
				dispatch({
					type: 'LOADING_BLOCK_BUFF_SUB_IST',
					payload: false
				});
				dispatch(getListItemBuffSub());
				if (res.data.status === 200) {
					Swal.fire(
			      		'Thành công!',
			      		'Hủy đơn thành công',
			      		'success'
			    	)
				} else {
					openBtComfirmAlert(res.data.message, 'error', 'Lỗi');
				}
			});
	  	}
	})
}

export const searchDataBuffSub = (params) => (dispatch, getState) => {
	dispatch({
		type: 'LOADING_BLOCK_BUFF_SUB_IST',
		payload: true
	});

	axios.get('/api/instagram/list/?type_api=buff_sub&object_id='+params, tokenConfig(getState))
	.then(res => {
		dispatch({
			type: 'LOADING_BLOCK_BUFF_SUB_IST',
			payload: false
		});
		if (res.data.status === 200) {
			dispatch({
				type: 'LIST_BUFF_SUB_USER_IST',
				payload: res.data.data
			});
		}
	});
}

export const getDataPriceFunction = (params) => (dispatch, getState) => {
	dispatch({
		type: 'LOADING_BLOCK_BUFF_SUB_IST',
		payload: true
	});
	let dataApi =  axios.get('/api/admin/get_price_function/?name='+params, tokenConfig(getState));
	dataApi.then(res => {
		dispatch({
			type: 'LOADING_BLOCK_BUFF_SUB_IST',
			payload: false
		});
		if (res.data.status === 200) {
			if (res.data.data.length > 0) {
				let dataPrice = res.data.data[0];
				let dataFormOld = getState().buffsub.formData;
				dispatch({
					type: 'CHANGE_DATA_FORM_IST_BUFFSUB',
					payload: {
						...dataFormOld,
						giatien: dataPrice.prices_web
					}
				});
				dispatch({
					type: 'DATA_PRICE_IS_FUNCTION_BUFFSUB_IST',
					payload: dataPrice
				});
			}
		}
	});
}

export const saveEditOrderAdmin = (nametb, data, closeM) => (dispatch, getState) => {
	let bodysend = {
		formdata: data,
		type_api: nametb
	};
	dispatch({
		type: 'LOADING_BLOCK_BUFF_SUB_IST',
		payload: true
	});
	axios.post('/api/facebook_buff/admin_edit_order/', bodysend, tokenConfig(getState))
	.then(res => {
		dispatch({
			type: 'LOADING_BLOCK_BUFF_SUB_IST',
			payload: false
		});
		if (res.data.status === 200) {
			dispatch(getListItemBuffSub());
			Swal.fire(
	      		'Thành công!',
	      		'Sửa thành công',
	      		'success'
	    	);
	    	closeM();
		} else {
			Swal.fire( 'Lỗi', res.data.message, 'error' )
		}
	}).catch(err => {
		console.log(err);
		Swal.fire( 'Lỗi', 'Có lỗi xảy ra!', 'error' );
    });
}

export const reLoadIdFb = (id) => (dispatch, getState) => {
	let bodysend = {
		id: id,
		type: 'instagram_buffsub'
	};
	dispatch({
		type: 'LOADING_BLOCK_BUFF_SUB_IST',
		payload: true
	});
	axios.post('/api/instagram/checkiddie/', bodysend, tokenConfig(getState))
	.then(res => {
		dispatch({
			type: 'LOADING_BLOCK_BUFF_SUB_IST',
			payload: false
		});
		dispatch(getListItemBuffSub());
		if (res.data.status === 200) {
			Swal.fire({icon: 'success', title: 'Thành công', text: 'Check thành công!'});
		} else {
			Swal.fire({icon: 'error', title: 'Lỗi', text: res.data.message});
		}
	});
}

export const openBtComfirmAlert = (message, type, title = '') => {
	Swal.fire({
		icon: type,
		title: title,
		text: message,
	});
}

export const getConfigMoDong = (instagram_type) => (dispatch, getState) => {
	dispatch({
		type: 'LOADING_BLOCK_BUFF_SUB_IST',
		payload: true
	});

	axios.get('/api/instagram/getconfig?type_api='+instagram_type, tokenConfig(getState))
	.then(res => {
		dispatch({
			type: 'LOADING_BLOCK_BUFF_SUB_IST',
			payload: false
		});
		if (res.data.status === 200) {
			if (instagram_type == 'instagram_buffsub') {
				dispatch({
					type: 'CONFIG_MO_DONG_IST_BUFF_SUB',
					payload: res.data
				});
			}
		}
	});
}

export const tokenConfig = getState => {
	// Get token from localhost
	const token = getState().auth.token;
	
	// Headers
	const config = {
		headers: {
			"Content-type": "application/json"
		}
	};
	
	// If token, add to headers
	if (token) {
		config.headers['ht-token'] = token;
	}
	
	return config;
};